import { Equipment } from '../../shared/model/equipment';
import { Branch } from '../../shared/model/branch';

export class JiraTicket {
  constructor(public created?,
              public os?,
              public invoiceNumber?,
              public equipment?: Equipment,
              public branch?: Branch,
              public vehiclePlate?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/model/jira-ticket.ts